import { callApi } from '@/utils/http-utils'

export interface ClusterResponse {
  id: number
  name: string
  description: string
  longFormDescriptor?: string
  instructionalDesignFeatures?: string
  empiricalSupport?: string
  learnerOutcomes?: string
  suitabilityForDiverseLearners?: string
  exemplarResearchPaper?: string
  isActive: boolean
  created: string
  updated?: string
  createdBy: string
  updatedBy?: string
}

export interface ClusterListResponse {
  totalCount: number
  data: ClusterResponse[]
}

export interface ClusterDetailResponse {
  cluster: ClusterResponse
  associatedModalities: Array<{
    id: number
    name: string
    description: string
  }>
}

export async function listClusters(limit = 50, offset = 0) {
  const res = await callApi(`data-api/clusters?limit=${limit}&offset=${offset}`, { method: 'GET' })
  const ct = res.headers.get('content-type') || ''
  if (!ct.includes('application/json')) {
    const text = await res.text()
    throw new Error(`Expected JSON but got ${ct}. ${text.slice(0, 200)}`)
  }
  const body = await res.json()
  const data = Array.isArray(body) ? body : body.data || body.items || body.results || []
  return { totalCount: body.totalCount ?? data.length, data }
}

export async function getClusterById(id: string | number) {
  const res = await callApi(`data-api/clusters/${id}`, { method: 'GET' })
  const ct = res.headers.get('content-type') || ''
  if (!ct.includes('application/json')) {
    const text = await res.text()
    throw new Error(`Expected JSON but got ${ct}. ${text.slice(0, 200)}`)
  }
  if (!res.ok) {
    const errorText = await res.text()
    throw new Error(`Failed to fetch cluster: ${errorText}`)
  }
  return res.json()
}
